export default "__VITE_ASSET__Dx$u8XVY__$_?no-inline__"